import { ProductoData } from '../../model/ProductoData';
import { CatalogoComponent } from '../catalogo/CatalogoComponent';

type ProductosRelacionadosProps = {
  productos: ProductoData[];
};

export const ProductosRelacionados = (props: ProductosRelacionadosProps) => {
  return (
    <CatalogoComponent
      data={props.productos}
      hideFilters={true}
      orden={0}
      moduloTitulo="Otros premios que te puedan interesar"
      prodPorFilaList={[1, 2, 3]}
      hidePage={true}
    />
  );
};
